"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserWordCloudComponentParameters = void 0;
exports.UserWordCloudComponentParameters = [
    {
        id: 'text',
        label: 'Word Cloud Text',
        description: 'Input Param - Sentence or text from which the user can select words',
        type: 'string',
        paramType: 'STRING',
        required: true,
    },
    {
        id: 'selected',
        label: 'Selected Words Indices',
        description: 'Output Param - Indices of the words selected by the user',
        type: 'output',
        paramType: 'ARRAY',
        required: true,
    },
    {
        id: 'other',
        label: 'Additional User Input',
        description: 'Output Param - Captures any additional user input (optional)',
        type: 'output',
        paramType: 'STRING',
        required: false,
    },
];
//# sourceMappingURL=UserWordCloudComponent.js.map